export const BUILD_ENV = 'qa';
export const BUILD_NUMBER = 2977;
export const BUILD_VERSION = '0.0.0';
export const JENKINS_BUILD_NUMBER = 414;
